import store from '@/states/index.js'

import BoMClientQuotation from '../BoMQuotation.vue'

export default [
    {
        path: '/client_materials_quotation',
        component: BoMClientQuotation,
        name: 'client_materials_quotation',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 2){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]
